import App from './App.vue';
import router from '@/router';
import 'amfe-flexible';
import 'vant/lib/index.css';
import '@/styles/index.less';
import Vconsole from 'vconsole';
import store from '@/store';

if (import.meta.env.VITE_USER_NODE_ENV === 'test') {
  new Vconsole();
}
const app = createApp(App);

app.use(router);
app.use(store);
app.mount('#app');
